import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import Loader from 'react-loader-advanced';
import cx from 'classnames';
// Component
import loader from '/public/Icons/lightModeLoader.gif';
import loaderDark from '/public/Icons/darkModeLoader.gif';
import s from './Loader.css';
class FullPageLoader extends React.Component {

    static propTypes = {
        children: PropTypes.node,
        show: PropTypes.bool.isRequired
    };

    static defaultProps = {
        show: false
    };

    spinner() {
        const { dropzoneLoaderClass } = this.props

        return <div className={cx(s.fullPageGifLoader, dropzoneLoaderClass)}>
            <img src={loader} className={'lightModeLoader'} />
            <img src={loaderDark} className={'darkModeLoader'} />
        </div>
    }

    render() {
        const { children, show } = this.props;
        return (
            <Loader show={show} message={this.spinner()}
                foregroundStyle={{ color: "white" }}
                backgroundStyle={{ backgroundColor: "rgba(249, 249, 249, 0.74)" }}>
                <div>
                    {children}
                </div>
            </Loader>
        );
    }
}

export default withStyles(s)(FullPageLoader);
